import { useDispatch } from 'react-redux'
import { editPermissions, EXTERNAL_LOAD_EDIT } from 'tennders-stracture/libs/permissions'
import GLink from 'tennders-market/common/components/element/GLink'
import GHref from 'tennders-market/common/components/element/GHref'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { ItemTypes } from 'tennders-common/enums/ItemTypes'
import { TransactionType } from 'tennders-transactions/types/TransactionType'
import { dispatchEditModal } from 'tennders-common/stores/modal/action'
import useSession from 'tennders-auth/hooks/useSession'
import useTranslation from 'next-translate/useTranslation'

type Props = {
            transaction: TransactionType,
            type?: string
            // eslint-disable-next-line react/no-unused-prop-types
            close?: any;
            board?: number | string;
}

export const withEditTransaction = (WrappedComponent) => (props: Props) => {
  const { transaction, type, board } = props
  const dispatch = useDispatch()
  const { isBroker } = useSession()
  const { t } = useTranslation()
  const setEditMode = (transaction) => dispatch(dispatchEditModal(transaction))
  const suffix = (transaction?.matchedTruck && transaction?.matchedLoad) ? '?transaction=true' : ''

  const key = type === ItemTypes.LOAD ? 'EDIT_LOAD' : 'EDIT_TRUCK'

  const fallBack = (
    <GHref
      className="text-center disabled"
      tip={t(transaction?.disabledActionTooltips
      && typeof transaction?.disabledActionTooltips[key] !== 'undefined'
        ? 'tableRow:' + transaction.disabledActionTooltips[key] : 'tableRow:noPermission')}>
      <WrappedComponent />
    </GHref>
  )

  const render = () => (type === ItemTypes.MATCHED
    ? (
      <div>
        <GHref
          onClick={() => setEditMode(transaction)}
          className="btn-link p-0 d-flex col flex-center cell-icon"
        >
          <WrappedComponent />
        </GHref>
      </div>
    )
    : (
      <div>
        <GLink
          className="btn-link p-0 d-flex col flex-center cell-icon"
          href={type === ItemTypes.LOAD && transaction.matchedLoad
            ? `/edit/load/${transaction.matchedLoad.id}${transaction?.matchedLoad?.toQuote ? ('?ltab=to-quote&' + suffix.replace('?', '')) : suffix}`
            : `/edit/truck/${transaction.matchedTruck && transaction.matchedTruck.id}${suffix}`}
        >
          <WrappedComponent />
        </GLink>
      </div>
    ))

  let requiredPermissions = editPermissions[board]

  if (type === ItemTypes.LOAD && !transaction.matchedLoad?.internalOwner && isBroker()) {
    requiredPermissions = EXTERNAL_LOAD_EDIT
  }

  if ((type === ItemTypes.LOAD && transaction?.disabledActions?.includes('EDIT_LOAD'))
      || (type === ItemTypes.TRUCK && transaction?.disabledActions?.includes('EDIT_TRUCK'))) {
    return fallBack
  }

  return (
    transaction.enabledOperations?.edit
      ? (
        <RequiresPermission
          fallbackComponent={fallBack}
          requiredPermissions={requiredPermissions}
        >
          {render()}
        </RequiresPermission>
      )
      : fallBack
  )
}
